import { AJUDA_WIKI_URL, Links } from '@/shared/constants/navegacao';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export default function AjudaPage() {
  useEffect(() => {
    window.open(AJUDA_WIKI_URL, '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <div className="p-4 text-center">
      <p className="mb-2">O manual de ajuda foi aberto em uma nova aba.</p>
      <a
        href={AJUDA_WIKI_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-link"
      >
        Abrir manual novamente
      </a>
      <span className="mx-1">·</span>
      <Link to={Links.Index} className="btn btn-link">
        Voltar ao início
      </Link>
    </div>
  );
}
